export enum AIType {
  /**
   * One-shot read of the "Type what happened" sentence in Add asset: names the
   * wizard flow and prefills what the sentence supports. Unlike AGENT it does
   * not hold a conversation — see store/ai/assetWizard.
   */
  ASSET_WIZARD = 'asset_wizard',
  /**
   * Which existing account a wizard's records should hang off. Given the user's
   * sentence and the accounts the repository actually has, it picks one — or
   * says none of them fits. Like ASSET_WIZARD it is one shot, not a
   * conversation; see store/ai/accountSuggestion.
   */
  ACCOUNT_SUGGESTION = 'account_suggestion',
  /**
   * The other half of the same step: which ownership type a *new* account
   * should be created as. Separate from ACCOUNT_SUGGESTION because it is a
   * different question with a different prompt — one picks something that
   * exists, the other picks what kind of thing to make.
   */
  ACCOUNT_TYPE_SUGGESTION = 'account_type_suggestion',
  /**
   * Tags worth applying to what the wizard will create. The only one of the
   * suggestion assistants that answers with a list, because an asset carries
   * several tags across several dimensions — see store/ai/tagSuggestion.
   */
  TAG_SUGGESTION = 'tag_suggestion',
}
